import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { executeApiAction } from '../../shared/utility/apiHelper';
import { getEvidenceDetails } from '../services/evidenceService';
import { getEvidenceDisposalRules } from '../services/evidenceDisposalRuleService';
import { matchesRuleConditions } from '../utility/disposalRuleMatching';

const useEvidencePortalItemDetail = () => {
  const dispatch = useDispatch();
  const agencyId = useSelector((state) => state.user?.userAgency);

  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [matchedRules, setMatchedRules] = useState([]);
  const [loading, setLoading] = useState(false);

  const openItem = useCallback(
    (ptsEvidenceID) => {
      if (!ptsEvidenceID) return;

      executeApiAction({
        setLoading,
        dispatch,
        action: () =>
          Promise.all([getEvidenceDetails(ptsEvidenceID), getEvidenceDisposalRules(agencyId)]),
        onSuccess: ([evidenceDetail, rules]) => {
          const enabledRules = (rules || []).filter((rule) => rule.enabled !== false);
          setMatchedRules(
            enabledRules.filter((rule) => matchesRuleConditions(evidenceDetail, rule.conditions))
          );
          setData(evidenceDetail);
          setOpen(true);
        },
      });
    },
    [dispatch, agencyId]
  );

  const closeItem = useCallback(() => {
    setOpen(false);
    setData(null);
    setMatchedRules([]);
  }, []);

  return { open, data, matchedRules, loading, openItem, closeItem };
};

export default useEvidencePortalItemDetail;
